// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/style.scss
// module id = 43
// module chunks = 0